/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DailyAdherenceScoreDto } from './DailyAdherenceScoreDto';
import {
    DailyAdherenceScoreDtoFromJSON,
    DailyAdherenceScoreDtoFromJSONTyped,
    DailyAdherenceScoreDtoToJSON,
    DailyAdherenceScoreDtoToJSONTyped,
} from './DailyAdherenceScoreDto';

/**
 * 
 * @export
 * @interface AdherenceSummaryResponseDto
 */
export interface AdherenceSummaryResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AdherenceSummaryResponseDto
     */
    timezone: string;
    /**
     * 
     * @type {DailyAdherenceScoreDto}
     * @memberof AdherenceSummaryResponseDto
     */
    today: DailyAdherenceScoreDto;
    /**
     * 
     * @type {DailyAdherenceScoreDto}
     * @memberof AdherenceSummaryResponseDto
     */
    yesterday: DailyAdherenceScoreDto;
    /**
     * 
     * @type {number}
     * @memberof AdherenceSummaryResponseDto
     */
    weeklyAveragePercentage: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdherenceSummaryResponseDto
     */
    monthlyAveragePercentage: number | null;
}

/**
 * Check if a given object implements the AdherenceSummaryResponseDto interface.
 */
export function instanceOfAdherenceSummaryResponseDto(value: object): value is AdherenceSummaryResponseDto {
    if (!('timezone' in value) || value['timezone'] === undefined) return false;
    if (!('today' in value) || value['today'] === undefined) return false;
    if (!('yesterday' in value) || value['yesterday'] === undefined) return false;
    if (!('weeklyAveragePercentage' in value) || value['weeklyAveragePercentage'] === undefined) return false;
    if (!('monthlyAveragePercentage' in value) || value['monthlyAveragePercentage'] === undefined) return false;
    return true;
}

export function AdherenceSummaryResponseDtoFromJSON(json: any): AdherenceSummaryResponseDto {
    return AdherenceSummaryResponseDtoFromJSONTyped(json, false);
}

export function AdherenceSummaryResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdherenceSummaryResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'timezone': json['timezone'],
        'today': DailyAdherenceScoreDtoFromJSON(json['today']),
        'yesterday': DailyAdherenceScoreDtoFromJSON(json['yesterday']),
        'weeklyAveragePercentage': json['weeklyAveragePercentage'],
        'monthlyAveragePercentage': json['monthlyAveragePercentage'],
    };
}

export function AdherenceSummaryResponseDtoToJSON(json: any): AdherenceSummaryResponseDto {
    return AdherenceSummaryResponseDtoToJSONTyped(json, false);
}

export function AdherenceSummaryResponseDtoToJSONTyped(value?: AdherenceSummaryResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timezone': value['timezone'],
        'today': DailyAdherenceScoreDtoToJSON(value['today']),
        'yesterday': DailyAdherenceScoreDtoToJSON(value['yesterday']),
        'weeklyAveragePercentage': value['weeklyAveragePercentage'],
        'monthlyAveragePercentage': value['monthlyAveragePercentage'],
    };
}

